import React from "react";
import "../styles/Footer.css";

function Footer() {
  return (
    <div>
      <footer className="designed">
        Designed and developed by Avani Vaishnav
        <p>
          <small>
            Copyright &copy; 2022 by Avani Vaishnav. All Rights Reserved.
          </small>
        </p>
      </footer>
    </div>
  );
}

export default Footer;
